import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { Firestore, collectionData, collection } from '@angular/fire/firestore';
@Component({
  selector: 'app-apply',
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.css'],
})
export class ApplyComponent {
  candidate: any;

  submitted: boolean = false;

  nameC = new FormControl('', [Validators.required, Validators.minLength(4)]);
  emailC = new FormControl('', [Validators.required, Validators.email]);
  phoneC = new FormControl('', [
    Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10),
    Validators.pattern('[0-9]+'),
  ]);
  cityC = new FormControl('', [Validators.required]);
  educationC = new FormControl('', [Validators.required]);
  streamC = new FormControl('', [Validators.required]);
  mathsC = new FormControl('', [
    Validators.required,
    Validators.pattern('[0-9]+'),
  ]);
  physicsC = new FormControl('', [
    Validators.required,
    Validators.pattern('[0-9]+'),
  ]);
  passportC = new FormControl('', [Validators.required]);

  constructor() {
    //this.applicationCollection = afs.collection<any>('applications');
  }

  addApplication() {
    // this.applicationCollection.add(this.candidate).then((res) => {
    //   this.candidate = {};
    //   this.submitted = true;
    // });
  }
}
